import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'vw-circle-icon',
    imports: [],
    styles: [`:host { display: block; }`],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0"/></svg>`
})
export class CircleIconComponent {}
